/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Ma', // 'Today',
  now: 'Most', // 'Now',
  backToToday: 'Vissza a mai napra', // 'Back to today',
  ok: 'Ok',
  clear: 'TÃ¶rlÃ©s', // 'Clear',
  month: 'HÃ³nap', // 'Month',
  year: 'Ãv', // 'Year',
  timeSelect: 'IdÅpont kivÃ¡lasztÃ¡sa', // 'Select time',
  dateSelect: 'DÃ¡tum kivÃ¡lasztÃ¡sa', // 'Select date',
  monthSelect: 'HÃ³nap kivÃ¡lasztÃ¡sa', // 'Choose a month',
  yearSelect: 'Ãv kivÃ¡lasztÃ¡sa', // 'Choose a year',
  decadeSelect: 'Ãvtized kivÃ¡lasztÃ¡sa', // 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'YYYY/MM/DD', // 'M/D/YYYY',
  dayFormat: 'DD', // 'D',
  dateTimeFormat: 'YYYY/MM/DD HH:mm:ss', // 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'ElÅzÅ hÃ³nap (PageUp)', // 'Previous month (PageUp)',
  nextMonth: 'KÃ¶vetkezÅ hÃ³nap (PageDown)', // 'Next month (PageDown)',
  previousYear: 'MÃºlt Ã©v (Control + left)', // 'Last year (Control + left)',
  nextYear: 'JÃ¶vÅ Ã©v (Control + right)', // 'Next year (Control + right)',
  previousDecade: 'ElÅzÅ Ã©vtized', // 'Last decade',
  nextDecade: 'KÃ¶vetkezÅ Ã©vtized', // 'Next decade',
  previousCentury: 'MÃºlt Ã©vszÃ¡zad', // 'Last century',
  nextCentury: 'JÃ¶vÅ Ã©vszÃ¡zad' // 'Next century',
};
